import { render, staticRenderFns } from "./Impresos.vue?vue&type=template&id=1e25f7f5"
import script from "./Impresos.vue?vue&type=script&lang=js"
export * from "./Impresos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports